import { useMemo, useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHashElement = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const hash = location.hash.slice(1);

    const scrollToElement = () => {
      const el = document.getElementById(hash);
      if (el) {
        window.scrollTo({
          behavior: 'smooth',
          top:
              el.getBoundingClientRect().top +
              window.scrollY +
              270,
        });
      } else {
        requestAnimationFrame(scrollToElement);
      }
    };

    scrollToElement();
  }, [ location ]);

  return null;
};

export default ScrollToHashElement;
